var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, Profiler, useContext, useMemo, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { debounce } from 'lodash';
export var SnackbarProvider = function (_a) {
    var children = _a.children;
    var _b = useState({
        title: '',
        isOpenSnackBar: false,
        message: '',
        status: 'success'
    }), statusSnackBar = _b[0], setStatusSnackBar = _b[1];
    var debouncedSnackBar = useMemo(function () {
        return debounce(function (severity, props) {
            var message = (typeof props === 'string' ? { message: props } : props).message;
            var title = typeof props === 'string' ? null : props.title;
            setStatusSnackBar(function (prev) { return (__assign(__assign({}, prev), { isOpenSnackBar: true, message: message, status: severity, title: title })); });
        }, 300);
    }, []);
    var snackbarAciton = useMemo(function () {
        return {
            success: function (props) { return debouncedSnackBar('success', props); },
            error: function (props) { return debouncedSnackBar('error', props); },
            warning: function (props) { return debouncedSnackBar('warning', props); },
            info: function (props) { return debouncedSnackBar('info', props); }
        };
    }, [debouncedSnackBar]);
    var handleCloseSnackBar = function () {
        setStatusSnackBar(function (prev) { return (__assign(__assign({}, prev), { isOpenSnackBar: false, message: '', status: 'success' })); });
    };
    return (_jsxs(SnackbarContext.Provider, { value: snackbarAciton, children: [children(snackbarAciton), statusSnackBar.isOpenSnackBar && (_jsx(Profiler, { id: 'snackbar', onRender: function () { }, children: _jsx(Snackbar, { open: statusSnackBar.isOpenSnackBar, autoHideDuration: 2000, onClose: handleCloseSnackBar, children: _jsxs(Alert, { onClose: handleCloseSnackBar, severity: statusSnackBar.status, variant: 'filled', sx: { width: '100%' }, children: [statusSnackBar.title && statusSnackBar.title !== '' && _jsx("strong", { children: statusSnackBar.title }), statusSnackBar.message] }) }) }))] }));
};
export var SnackbarContext = createContext(null);
export var useSnackbarContext = function () {
    var context = useContext(SnackbarContext);
    if (!context) {
        throw new Error('useSnackbarContext must be used within a SnackbarProvider');
    }
    return context;
};
